import React from "react"
import { Close } from '@mui/icons-material'
import { Divider, IconButton, Typography, Modal, Fade, Card, CardHeader, CardContent, CardActions } from '@mui/material'
import styles from './Modal.module.scss'

export default function ModalModel({open, handleClose, title, children, buttons, elevation = 3, limitWidth = true, subheader, hideHeader = false, overrideStyle = {}}) {

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={styles['modal']}
      open={open}
      onClose={handleClose}
      components={{
        Props: {
          backdrop: {
            timeout: 500
          }
        }
      }}
    >
      <Fade in={open}>
        <Card elevation={elevation}>
          {!hideHeader && 
          <>
            {title && <><CardHeader
              disableTypography
              classes={{content: styles['card-header-content']}}
              title={<Typography variant="h2">{title}</Typography>}
              subheader={subheader}
              action={<IconButton onClick={handleClose}>{ handleClose && <Close/> }</IconButton>}
            />
            <Divider/></>}
          </> }
          <CardContent className={[styles['content'], limitWidth ? styles['limit-width'] : '', overrideStyle?.cardContent].join(' ')}>
            {children}
          </CardContent>
          { buttons && (
            <>
              <Divider/>
              <CardActions className={styles['actions']}>
                {buttons}
              </CardActions>
            </>
          )}
        </Card>
      </Fade>
    </Modal>
  )
}
